<!--
 Copyright (c) Qwoach LLC 2020. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 8/25/20
-->

<template>
	<FormElementTemplate
		:formElement="formElement"
		:viewMode="viewMode"
		v-bind="$attrs">


		<template #body>
			<FormTextRow
				class="form-answer "
				:class="{'form-answer-edit': isEditMode, 'form-answer': !isEditMode, 'hide-placeholders-on-print': isEditMode, 'px-0': (isEditMode && !isSelected) || isViewMode}"
				v-model="formElement.answer"
				:forceShowWhenEmpty="true"
				:readonly="!isAnswerMode"
				:borderDotted="!isAnswerMode"
				:multiline="isMultiline"
				:placeholder="answerPlaceholder"
				@change="$emit('change', formElement)"
			></FormTextRow>
		</template>

	</FormElementTemplate>
</template>

<script>
import FormElementText from "@/core/modules/coach/Resources/Forms/model/FormElements/General/FormElementText";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseFormElement from "@/core/modules/coach/Resources/Forms/FormElements/BaseFormElementView.vue";
import FormElementTemplate from "@/core/modules/coach/Resources/Forms/FormElements/FormElementTemplate.vue";
import FormElementFullName from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/FormElementFullName";
import FormElementPhoneNumber
	from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/FormElementPhoneNumber";
import FormElementEmailAddress
	from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/FormElementEmailAddress";

export default {
	name: "FormElementTextView",
	components: {FormElementTemplate, FormTextRow},
	extends: BaseFormElement,
	props: {
		formElement: [FormElementText, FormElementFullName, FormElementPhoneNumber, FormElementEmailAddress]
	},

	data() {
		return {
		}
	},


	methods: {

	},

	computed: {
		answerPlaceholder() {
			// if (this.isViewMode) {
			// 	return "Your answer"
			// }
			// switch (this.formElement.type) {
			// 	case FormElementType.MULTILINE:
			// 		return "Answer text"
			// }
			// return "Short answer text"
			if(this.isAnswerMode){
				return "Your answer"
			}
			if(this.isViewMode){
				return "No answer provided"
			}
			return "Client's answer"
		},

		isMultiline(){
			return this.formElement.type === FormElementType.MULTILINE
		}

	}

}
</script>

<style>

</style>
